"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnceHubUtil = void 0;
var getId = function getId(goOnceHubUrl) {
  // if calendar url is undefined / missing (e.g. no physicain) return null
  if (!goOnceHubUrl) {
    return null;
  }
  // If calendar url is anything else (e.g. google.com) return undefined
  return goOnceHubUrl.split('go.oncehub.com/', 2)[1];
};
var getIdByState = function getIdByState(state) {
  return "".concat(process.env.REACT_APP_ONCE_HUB_PHYSICIAN_CALL_ID, "-").concat(state);
};
var getQueryString = function getQueryString(str) {
  if (!str) {
    return '';
  }
  return "?".concat(str.split('?', 2)[1]);
};
var OnceHubUtil = {
  getId: getId,
  getIdByState: getIdByState,
  getQueryString: getQueryString
};
exports.OnceHubUtil = OnceHubUtil;